import styled from 'styled-components';

interface BottomNavItemProps {
  active?: boolean;
}

const BottomNavItemStyled = styled.div<BottomNavItemProps>(
  ({ theme, active }) => {
    return {
      cursor: 'pointer',
      padding: `${theme.space[1]} ${theme.space[3]}`,
      display: 'inline-flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
      flex: '1',
      color: active ? theme.color.primary : theme.color.wfBlack,
    };
  },
);

const LabelStyled = styled.span(({ theme }) => {
  return {
    fontSize: theme.font.size.xsmall,
  };
});

export { BottomNavItemStyled, LabelStyled };
